<ng-container *ngIf="dt">
  {{ dt.getFullYear() }} / {{ dt.getMonth() + 1 | number : "2.0-2" }} /
  {{ dt.getDate() | number : "2.0-2" }}
</ng-container>
